import Image from 'components/Common/Image'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import type { LoyaltyLandingPageBenefitDetails } from '../LoyaltyLandingPageData'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'

const SmallTile = styled.div`
  display: grid;
  grid-template: 1fr / ${rem(100)} auto;
  gap: ${rem(16)};

  ${mediaQueryUp.tablet} {
    grid-template: ${rem(160)} auto / 1fr;
  }
`

interface Props {
  tile: LoyaltyLandingPageBenefitDetails
  promotion?: App.LabFeatureFlagResult
}

function LoyaltyLandingPageSmallTile(props: Props) {
  const { tile, promotion } = props
  return <SmallTile key={tile.image.id}>
    <Image image={tile.image} height={160} dpr={2} fit="center" />
    <VerticalSpacer gap={8}>
      <Group direction="horizontal" gap={8} verticalAlign="start" desktopVerticalAlign="center" horizontalAlign="start">
        <Heading variant="heading5">{tile.title}</Heading>
        {promotion?.enabled && <PromotionLabel variant="premium">New</PromotionLabel>}
      </Group>
      <BodyText variant="medium">{tile.description}</BodyText>
    </VerticalSpacer>
  </SmallTile>
}

export default LoyaltyLandingPageSmallTile
